import React from 'react';
import classes from "./Input.module.css";

const TextArea = ({text, name, width, height, onChange}) => {
  return (
    <textarea placeholder={text} name={name} onChange={onChange} id={name} className={`${classes.input} ${classes.textarea}`} style={{width: width, height: height ? height : "fit-content"}} />
  );
};

export default TextArea;